import { Card, Row, Col, Typography, Button } from 'antd';
import notFoundImg from '../../../assets/notFound.png';
import { LogoutOutlined } from '@ant-design/icons';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import './unauthorized.scss';
const { Paragraph, Title } = Typography;

const Unauthorized = () => {

    const { instance } = useMsal();
    const { t } = useTranslation();
    const handleLogout = () => {
        instance.logoutRedirect();
    };

    return (
        <div className="notAuth">
            <Card>
                <Row gutter={{ lg: 24 }}>
                    <Col className="gutter-row textNF" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                        <Title level={3}>{t('messages.unauthorized')}</Title>
                        <Paragraph>{t('messages.unauthorizedMessage')}</Paragraph>
                        <Button onClick={() => handleLogout()} type="dashed" icon={<LogoutOutlined />}>{t('general.singOut')}</Button>
                    </Col>
                    <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                        <img src={notFoundImg} alt="Page not found" />
                    </Col>
                </Row>
            </Card>
        </div>
    );
}
export default Unauthorized;